import React from 'react';
import Layout from '../Layout';
import Signup from '../Forms/Signup/Signup';

export default function SignUp() {
  return (
    <Layout id="signupCtn">
      <Signup />
    </Layout>
  );
}
